import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useI18n, format } from '@popety_io/popety-io-lib'
import { useSelector } from 'react-redux'
import { estimateSelector } from '../../redux'

import SunlightTimeBox from './SunlightTimeBox'
// import PotentialSolar from './PotentialSolar'
import EstimateSunlightHeader from './EstimateSunlightHeader'

const Sunlight = () => {
  const { t } = useI18n()
  const estimate = useSelector(estimateSelector)
  const [isToday, setIsToday] = useState<boolean>()

  const todayDate = new Date()
  const selectedDate = new Date(estimate?.sunlightDate)

  useEffect(() => {
    setIsToday(
      todayDate.getDate() === selectedDate.getDate() &&
        todayDate.getMonth() === selectedDate.getMonth() &&
        todayDate.getFullYear() === selectedDate.getFullYear(),
    )
  }, [estimate?.sunlightDate])

  return (
    <>
      <Box
        position="sticky"
        top={0}
        pt={2}
        zIndex={10}
        bgcolor="background.paper"
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: '4px',
            textTransform: 'uppercase',
          }}
          fontSize="1.7rem"
          fontWeight={500}
        >
          {t('land.history.sunlight')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#969696',
            paddingBottom: '10px',
          }}
          fontSize="1rem"
        >
          {t('estimate.Heure d’ensoleillement estimée à cette addresse')}
        </Typography>
      </Box>
      <EstimateSunlightHeader data={estimate} />
      <Box id="plot-sunlight">
        <Box
          display="flex"
          flexDirection="column"
          gap={5}
          pb={{ xs: 8, lg: 4 }}
        >
          <SunlightTimeBox
            sunlightTime={estimate.sunlightTime}
            sunlightHours={estimate.sunlightHours}
            title={`${
              isToday ? `${t('land.sun.today').toUpperCase()} - ` : ''
            }  ${format(estimate.sunlightDate, 'PPP')}`}
          />

          <SunlightTimeBox
            sunlightTime={estimate.sunlightWinterTimes}
            sunlightHours={estimate.sunlightWinterHours}
            title={`${t('land.sun.winter').toUpperCase()} - ${format(
              estimate.sunlightWinterTimes?.date,
              'dd MMMM',
            )}`}
          />

          <SunlightTimeBox
            sunlightTime={estimate.sunlightSummerTimes}
            sunlightHours={estimate.sunlightSummerHours}
            title={`${t('land.sun.summer').toUpperCase()} - ${format(
              estimate.sunlightSummerTimes?.date,
              'dd MMMM',
            )}`}
          />
        </Box>
      </Box>
    </>
  )
}

export default Sunlight
